import { useEffect, useState } from 'react';
import './financial.validation.pending.css';
import { ApiService } from 'lib/http.service';
import { env, predefinedConstants } from '../../constants/global.vars';
import copyIcon from "../../assets/feather/copy.svg";
import bankIcon from "../../assets/icons/bank.svg";
import iconCheck from "../../assets/icons/check-star-circle.png";
import iconInfo from "../../assets/feather/info.svg";
import ReactModal from 'react-modal';
import { copyMemberNumber } from '../../services/misc.functions';
import { Subject, Subscription } from 'rxjs';
import { Storage } from "../../services/localstorege.service";

export const financialValidationService: { data: any } = { data: null };
export const financialValidationServiceSubject = new Subject();

const FinancialValidationPending = (props: any) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [bankAccounts, setBankAccounts] = useState<any>([]);
  const [selected, setSelected] = useState<any>(null);
  const [defaultBank, setDefaultBank] = useState<any>(null);

  useEffect(() => {
    const financialValidationSubscription: Subscription = financialValidationServiceSubject.subscribe((obj: any) => {
      if (obj) {
        setShowModal(true);
        getBankAccounts();
      } else {
        closeModal();
      }
    });

    return () => {
      financialValidationSubscription.unsubscribe();
    };
  }, []);

  const getBankAccounts = async () => {
    const api = new ApiService();
    api
      .start("get", env.accounting_api + "/accounting/api/list-bank-account/", null, false)
      .then((res: any) => {
        setBankAccounts(res.data);
        for (const bank of res.data) {
          if (bank.bank.code === "10") {
            setDefaultBank(bank);
          }
        }
      })
      .catch((e: any) => console.error(e));
  };

  const closeModal = () => {
    setShowModal(false);
    setBankAccounts([]);
    setSelected(null);
    setDefaultBank(null);
  };

  if (!showModal) {
    return <>{props.children}</>;
  }

  return (
    <>
      {props.children}
      <div className="modal show" style={{ maxWidth: 'calc(100vw - 40px)' }}>
        <div className="body" style={{ maxHeight: 'calc(100vh - 150px)', overflow: 'auto' }}>
          <div className="financial-validation-container">
            <div className="warning-box">
              <div className="warning-icon">⚠️</div>
              <div className="warning-content">
                <h3>Mevzuat ve Yasal Bilgilendirme</h3>
                <p>
                  Mevzuat gereği, üyeliğiniz oluşturulmadan önce kimlik bilgilerinizle uyumlu bir banka hesabından (hesap sahibinin siz olduğunuz bir banka hesabından) ödeme yapmanız ve bu hesabın size ait olduğunun Şirketimiz tarafından doğrulanması gerekmektedir. Bu kapsamda, üyelik kaydınıza devam edebilmek için, kendi banka hesabınızı kullanarak aşağıda bilgileri bulunan hesaplarımıza dilediğiniz tutarda havale veya EFT yapabilir ya da anlaşmalı olduğumuz bankaların şans oyunları ödemeleri bölümünden T.C. kimlik numaranızla yine dilediğiniz tutarda ödeme gerçekleştirebilirsiniz.
                  Ödemeniz Şirketimize ulaştıktan sonra, ödeme yapılan banka hesabının size ait olup olmadığı kontrol edilecektir. Ödemenin size ait bir banka hesabından yapıldığının tespit edilmesi halinde, üyeliğiniz oluşturulacak ve gönderdiğiniz tutar üyelik bakiyenize yansıtılacaktır. Ödemenin size ait olmayan bir banka hesabından yapılması durumunda ise gönderilen tutar ilgili banka hesabına iade edilecektir.
                </p>
              </div>
            </div>


            <h2 className="transfer-title">
              EFT / HAVALE / FAST
            </h2>
            <div className="transfer-section">
              <p className="transfer-description">
                Kendi adınıza ait vadesiz hesabınız ile aşağıdaki banka hesabına FAST ile 7/24 veya EFT saatlerinde Türk Lirası yatırabilirsiniz.
              </p>
            </div>

            <div className="account-section">
              <label className="account-label">HESAP SAHİBİ</label>
              <div className="account-holder">
                <span>{predefinedConstants.account_holder}</span>
                <button className="copy-btn" onClick={() => copyMemberNumber(predefinedConstants.account_holder)}>
                  <img className="ms-2" width={16} alt={"copyIcon"} src={copyIcon} />
                </button>
              </div>
            </div>

            <div className="iban-section">
              <label className="iban-label">IBAN NUMARASI</label>
              <div className="iban-holder">
                <span>{predefinedConstants.iban}</span>
                <button className="copy-btn" onClick={() => copyMemberNumber(predefinedConstants.iban)}>
                  <img className="ms-2" width={16} alt={"copyIcon"} src={copyIcon} />
                </button>
              </div>
            </div>

            <div className="banks-section">
              <h3 className="banks-title">
                <span className="icon">
                  <img alt={"bank"} width={18} src={bankIcon} />
                </span> ANLAŞMALI BANKALAR
              </h3>
              <div className="banks-info">
                <span className="info-icon">
                  <img className="ms-2" width={16} alt={"iconInfo"} src={iconInfo} />
                </span>
                <p>
                  Anlaşmalı olan bankalarımızın uygulamalarını kullanarak <span className="fw-bold">Şans Oyunları Ödemeleri</span> altından <span className="fw-bold text-primary">4nala'</span>yı seçerek para gönderebilirsiniz.
                </p>
              </div>
              {/* <div className="reference-id-info">
                <p>
                  <strong>Referans Numarası:</strong>{" "}
                  {JSON.parse(Storage.get("financial_validation_message_data") || "{}").temp_id}
                  <button
                    className="copy-btn"
                    onClick={() =>
                      copyMemberNumber(JSON.parse(Storage.get("financial_validation_message_data") || "{}").temp_id)
                    }
                  >
                    <img className="ms-2" width={16} alt={"copyIcon"} src={copyIcon} />
                  </button>
                </p>
              </div> */}
              <div className="banks-grid">
                {bankAccounts.map((bank: any) => (
                  <div
                    key={bank.id}
                    className={'bank-item'}
                    onClick={() => setSelected(bank)}
                  >
                    <img alt={"bank"} width={75} src={bank.bank.logo !== "" ? `${env.cdn_host}${bank.bank.logo}` : bankIcon} />
                    <span className="bank-name">{bank.bank.name}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="info-box">
              <span className="info-icon">
                <img className="ms-2" width={18} alt={"iconInfo"} src={iconInfo} />
              </span>
              <div>
                <p>
                  Para yatırma işlemini tamamladıktan birkaç dakika sonra hesabınıza giriş yapabilirsiniz.
                </p>
                <p>
                  Herhangi bir sorun yaşamanız halinde <strong>0850 441 64 64</strong> numaralı müşteri hizmetlerimizi arayabilirsiniz.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="footer p-2 text-end">
          <button
            className="btn btn-secondary w-100"
            onClick={closeModal}
          >
            Anladım
          </button>
        </div>
      </div>
      <div
        onClick={closeModal}
        className="modal-backdrop show"
      ></div>

      <ReactModal
        ariaHideApp={false}
        isOpen={selected !== null}
        onRequestClose={() => {
          setSelected(null);
        }}
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            maxWidth: 'calc(100vw - 80px)',
            width: '460px',
            maxHeight: 'calc(100vh - 100px)',
            transform: 'translate(-50%, -50%)',
            borderRadius: '1rem',
          }, overlay: {
            zIndex: 99999,
            backgroundColor: 'rgba(0, 0, 0, 0.25)',
            backdropFilter: 'blur(10px)',
          }
        }}
        contentLabel="">

        {selected && <>
          <h3>{selected.bank.name}</h3>
          <p>Bankaya ait şans oyunu ödemesi yolu ile hesabınıza bakiye yükleyebileceğiniz ödeme kanalları
            aşağıda listelenmiştir. </p>
          <table className="table table-bordered rounded">
            <tbody>
              <tr>
                <th className={"text-left"}>Mobil Bankacılık</th>
                <td className={"text-center"}>
                  <img alt={"iconCheck"} width={30} src={iconCheck} />
                </td>
              </tr>
              <tr>
                <th className={"text-left"}>ATM Kartlı İşlem</th>
                <td className={"text-center"}>
                  <img alt={"iconCheck"} width={30} src={iconCheck} />
                </td>
              </tr>
              <tr>
                <th className={"text-left"}>Telefon Bankacılığı</th>
                <td className={"text-center"}><img alt={"iconCheck"} width={30} src={iconCheck} /></td>
              </tr>

            </tbody>
          </table>
        </>}
      </ReactModal>
    </>
  );
};

export default FinancialValidationPending;
